

































import { Vue, Component } from 'vue-property-decorator';
import WebHeader from '@/components/business/WebHeader.vue';
import WebSwiper from '@/components/ui/WebSwiper.vue';
import Tuition from '@/components/business/Tuition.vue';
import UserVoice from '@/components/business/UserVoice.vue';
import Safety from '@/components/business/Safety.vue';
import scaleEl from '@/util/scale';

// import Swiper from '@/components/swiper/Swiper.vue';
import { biHottag } from '@tencent/ppd-base-libs';
import { checkIsPc, checkIsMobile, device, updateDevice } from '@/util/mediaCheck';
@Component({
  components: {
    WebHeader,
    WebSwiper,
    Tuition,
    UserVoice,
    Safety,
  },
})
export default class Home extends Vue {
  public device = device;
  public isPc = checkIsPc();
  public isMobile = checkIsMobile();
  public created() {
    biHottag('weremit.website.homepage.click');
  }
  public mounted() {
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    window.addEventListener(resizeEvt, () => {
      updateDevice();
    });
    // pc页面需要做缩放，移动端用vw不用缩放
    if (this.isPc) {
      scaleEl((this.$refs.webHeader as Vue).$el);
      scaleEl((this.$refs.safety as Vue).$el);
      scaleEl((this.$refs.user as Vue).$el);
      scaleEl(document.getElementById('dialog-inner'), 1080, '50%', '50%');
      scaleEl(document.getElementById('tuition'));
    }
  }

  // 返回首页
  handleLogoClick() {
    // @ts-ignore
    this.$refs.webSwiper.swiper.slideTo(0);
  }
}
